var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile" },
    [
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                {
                  staticClass:
                    "category-name is-size-4 has-text-weight-semibold",
                },
                [_vm._v(_vm._s(_vm.category))]
              ),
              _c("div", { staticClass: "is-size-5" }, [
                _vm._v(_vm._s(_vm.subtitle) + " "),
                _c(
                  "span",
                  {
                    class: {
                      "has-text-danger": _vm.selectedCount > _vm.maxSelected,
                    },
                  },
                  [
                    _vm._v(
                      "(" +
                        _vm._s(_vm.selectedCount) +
                        "/" +
                        _vm._s(_vm.imagesWithInfo.length) +
                        ")"
                    ),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _c("div", { staticClass: "buttons" }, [
                _vm.imagesWithInfo.length > 0
                  ? _c(
                      "a",
                      {
                        staticClass: "button tooltip",
                        attrs: { "data-tooltip": "Select all" },
                        on: {
                          click: function ($event) {
                            return _vm.setSelectedStatusAll(true)
                          },
                        },
                      },
                      [_vm._m(0)]
                    )
                  : _vm._e(),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Deselect all" },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedStatusAll(false)
                      },
                    },
                  },
                  [_vm._m(1)]
                ),
              ]),
            ]),
          ]),
          _vm.isLoadingImages
            ? _c("div", { staticClass: "columns is-multiline dragable-box" }, [
                _vm._m(2),
              ])
            : _vm.imagesWithInfo.length === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "content has-text-grey is-multiline dragable-box",
                },
                [_vm._m(3)]
              )
            : _c(
                "div",
                { staticClass: "columns is-multiline dragable-box" },
                _vm._l(_vm.imagesWithInfo, function (image, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "column is-narrow p-2" },
                    [
                      image.imageContent
                        ? _c(
                            "div",
                            {
                              staticClass: "card",
                              staticStyle: {
                                "box-shadow": "0 0 0 1px #d9d9d9",
                              },
                            },
                            [
                              _c("header", { staticClass: "card-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-header-title p-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "columns is-gapless",
                                        staticStyle: { width: "100%" },
                                      },
                                      [
                                        _c("div", { staticClass: "column" }, [
                                          _c("div", { staticClass: "field" }, [
                                            _c(
                                              "div",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex is-align-items-center",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pretty p-icon p-curve p-smooth mr-2",
                                                        staticStyle: {
                                                          "font-size":
                                                            "0.875rem",
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                image.isSelected,
                                                              expression:
                                                                "image.isSelected",
                                                            },
                                                          ],
                                                          attrs: {
                                                            id: `chk-pretty-image1${index}`,
                                                            name: `chk-pretty-select-image${index}`,
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                image.isSelected
                                                              )
                                                                ? _vm._i(
                                                                    image.isSelected,
                                                                    null
                                                                  ) > -1
                                                                : image.isSelected,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    image.isSelected,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        image,
                                                                        "isSelected",
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        image,
                                                                        "isSelected",
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    image,
                                                                    "isSelected",
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.setSelectedStatus(
                                                                  $event,
                                                                  image.quoteImageId
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._m(4, true),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "card-image" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewImage(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "figure",
                                      { staticClass: "image is-96x96" },
                                      [
                                        image
                                          ? _c("img", {
                                              key: image.quoteImageId,
                                              staticClass: "image is-96x96",
                                              staticStyle: {
                                                "object-fit": "cover",
                                              },
                                              attrs: {
                                                src: image.imageContent,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
        ]),
      ]),
      _vm.isCarouselModalActive
        ? _c("bulma-carousel-modal", {
            attrs: {
              "image-width": 800,
              "image-height": 600,
              active: _vm.isCarouselModalActive,
              "image-ids": _vm.imageIds,
              "start-index": _vm.carouselStartIndex,
            },
            on: {
              "update:active": function ($event) {
                _vm.isCarouselModalActive = $event
              },
              close: function ($event) {
                return _vm.closeCarousel()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section" }, [
      _c("div", {
        staticClass:
          "is-loading-image-popup content has-text-grey has-text-centered",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-one-fifth has-text-centered" }, [
      _c("span", { attrs: { icon: "icon is-large" } }, [
        _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
      ]),
      _c("div", [_vm._v("No Images")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-success" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }